import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const ArrowRightThin = (props) => (
  <Icon viewBox="0 0 6 14" {...props}>
    <g>
      <path id="Dark-Breadcrumb-Arrow" d="M.8 0L0 .7 4.6 7 0 13.3l.8.7L6 7z" />
    </g>
  </Icon>
);
/*eslint-enable */

export default ArrowRightThin;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/ArrowRightThin.js